import React, { useState, useEffect, useRef } from "react";
import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import axios from "axios";
import CustomSnackbar from "../../../../CustomSnackbar";
import {
  TableCell,
  TableContainer,
  TableRow,
  Box,
  Button,
} from "@material-ui/core";
import moment from "moment";
registerAllModules();

function ExpenseTable_V2({
  formState,
  setFormState,
  setGLAccountTotal,
  disable,
}) {
  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const columnHeaders = [
    "Expense Date",
    "Description",
    "Amount",
    "GL Account",
    "Cost Center",
    "CC Owner Code",
    "CC Owner",
    "Fixed Asset",
    "TType",
    "Profit Center",
  ];
  const adjustAmountOnGLTable = (tempArr) => {
    let newAmount = Number(formState?.invoice_Amount);
    if (tempArr.length > 0) {
      for (let i = 0; i < tempArr.length; i++) {
        const item = tempArr[i];
        // if (index === 0 && item.amount == 0) {
        newAmount = newAmount - Number(item.amount);
        // }
      }
    }
    return newAmount;
  };

  const tableData = {
    expenseDate: moment().format("YYYY-MM-DD"),
    description: "",
    amount: 0,
    glAccount: "",
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    fixedAsset: "",
    tType: "",
    profitCenter: "",
  };
  const addInput = () => {
    const num = Math.random();
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: [...formState.Expense_Accounts_list, tableData],
    }));
  };
  const handleBeforeChange = (changes, source) => {
    if (source == "CopyPaste.paste" && changes[0][1] == 1)
      changes[0][3] = changes[0][3] = changes[0][3].replaceAll(",", "").trim();
  };

  const handleBeforeRemoveRow = (a, b, c, d, e, f) => {
    let tempArr = formState?.Expense_Accounts_list;
    for (let index = 0; index < c.length; index++) {
      const rowIndex = c[index];
      const rowId = formState?.Expense_Accounts_list[rowIndex].rowId;
      tempArr = tempArr.filter((x) => x.rowId !== rowId);
    }
    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: tempArr,
    }));
  };
  const handleAfterChange = async (changes, source) => {
    if (changes == null || changes == undefined) return;
    var self = this;
    const str = JSON.stringify(formState?.Expense_Accounts_list);
    const tempArr = JSON.parse(str);
    for (let i = 0; i < changes.length; i++) {
      tempArr[changes[i][0]]["accountId"] = 0;
      tempArr[changes[i][0]]["accountType"] = "Debit";
      tempArr[changes[i][0]]["invoice_Id"] = Number(formState.invoice_Id);

      if (!tempArr[changes[i][0]]?.rowId) {
        const num = Math.random();
        tempArr[changes[i][0]].rowId = num;
      } else if (changes[i][1] == "expenseDate") {
        tempArr[changes[i][0]]["expenseDate"] = changes[i][3];
      }
      if (changes[i][1] == "costCenter") {
        var _cc = changes[i][3];
        // var data = { 'costCenterCode': _cc.split('-')[0].trim() };
        if (tempArr[changes[i][0]]["profitCenter"]) {
          setAlertMessage(
            "Profit center is already entered, so can't select cost center"
          );
          tempArr[changes[i][0]]["costCenterOwner"] = "";
          tempArr[changes[i][0]]["costCenterOwnerName"] = "";
          tempArr[changes[i][0]]["costCenter"] = "";
        } else {
          if (_cc) {
            await axios({
              method: "get", //you can set what request you want to be
              url: `${
                process.env.REACT_APP_API_URL
              }/api/Invoices/GetEmployeeByCostCenter_v1/${_cc
                .split("-")[0]
                .trim()}`,
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response.data != undefined) {
                  tempArr[changes[i][0]]["costCenterOwner"] =
                    response.data.employeeCode;
                  tempArr[changes[i][0]]["costCenterOwnerName"] =
                    response.data.employeeName;

                  if (i === changes.length - 1) {
                    setFormState((formState) => ({
                      ...formState,
                      Expense_Accounts_list: tempArr,
                    }));
                  }
                }
              })
              .catch(function (err) {
                console.log(err);
              });
            await axios({
              method: "get", //you can set what request you want to be
              url: `${
                process.env.REACT_APP_API_URL
              }/api/Invoices/GetCostCenters_v1/${_cc.split("-")[0].trim()}`,
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response.data != undefined) {
                  tempArr[changes[i][0]]["costCenter"] =
                    response.data[0].CostCenterCode +
                    " - " +
                    response.data[0].Name;

                  if (i === changes.length - 1) {
                    setFormState((formState) => ({
                      ...formState,
                      Expense_Accounts_list: tempArr,
                    }));
                  }
                }
              })
              .catch(function (err) {
                console.log(err);
              });
          } else {
            tempArr[changes[i][0]]["costCenterOwner"] = "";
            tempArr[changes[i][0]]["costCenterOwnerName"] = "";
            tempArr[changes[i][0]]["costCenter"] = "";
          }
        }
      } else if (changes[i][1] == "glAccount") {
        var _ca = changes[i][3];
        if (_ca != null && _ca != "" && _ca.split("-").length > 0) {
          // old value

          tempArr[changes[i][0]]["glAccount"] = changes[i][3];
          // if (changes.length > 1) {
          let _gl = "-1";
          if (_ca != null && _ca != "" && _ca.split("-").length > 0) {
            _gl = _ca.split("-")[0].trim();
          }
          await axios({
            method: "get", //you can set what request you want to be
            url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${_gl}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data.length > 0)
                tempArr[changes[i][0]]["glAccount"] =
                  response.data[0].GLAccount +
                  " - " +
                  response.data[0].ShortText;
              else tempArr[changes[i][0]]["glAccount"] = "";

              if (i === changes.length - 1) {
                setFormState((formState) => ({
                  ...formState,
                  Expense_Accounts_list: tempArr,
                }));
              }
              // if (changes.length === 1) {
              //   var amt = formState?.invoice_Amount - formState?.salesTaxAmount;
              //   var amt1 = 0;
              //   tempArr.forEach(function (v, k) {
              //     if (v[1] != undefined && k != changes[i][0]) amt1 += v[1];
              //   });
              //   tempArr[changes[i][0]]["amount"] = amt - amt1;
              // }
            })
            .catch(function (err) {
              console.log(err);
            });
          // }

          //return;
        }
        // var instance = self.getInstance();
      } else if (changes[i][1] == "amount") {
        if (changes[i][1]) {
          const amt = changes[i][3];
          if (typeof amt === "string") {
            const amt1 = Number(amt.replace(/,/g, ""));
            tempArr[changes[i][0]]["amount"] = amt1.toFixed(2);
          } else {
            tempArr[changes[i][0]]["amount"] = amt.toFixed(2);
          }
        } else tempArr[changes[i][0]]["amount"] = 0;
      } else if (changes[i][1] == "profitCenter") {
        if (!tempArr[changes[i][0]]["costCenter"]) {
          tempArr[changes[i][0]]["profitCenter"] = changes[i][3];
        } else {
          setAlertMessage(
            "Cost center is already selected, so can't enter profit center"
          );
          tempArr[changes[i][0]]["profitCenter"] = "";
        }
      } else if (changes[i][1] == "description") {
        tempArr[changes[i][0]]["description"] = changes[i][3];
      } else if (changes[i][1] == "fixedAsset") {
        tempArr[changes[i][0]]["fixedAsset"] = changes[i][3];
      } else if (changes[i][1] == "tType") {
        tempArr[changes[i][0]]["tType"] = changes[i][3];
      }
    }

    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: tempArr,
    }));
  };
  useEffect(() => {
    const data = [
      {
        data: "expenseDate",
        width: 170,
        type: "date",
        dateFormat: "YYYY-MM-DD",
      },
      {
        data: "description",
        width: 200,
        type: "text",
      },
      {
        data: "amount",
        width: 170,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "glAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "costCenter",
        type: "autocomplete",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "costCenterOwner",
        width: 1,
        type: "text",
        readOnly: true,
      },
      {
        data: "costCenterOwnerName",
        width: 200,
        type: "text",
        readOnly: true,
      },
      {
        data: "fixedAsset",
        width: 110,
        type: "text",
      },
      {
        data: "tType",
        width: 110,
        type: "text",
      },
      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
    ];

    setColumns(data);
  }, [formState?.Expense_Accounts_list]);
  const calculateTotalAmount = () => {
    const totalAmount = formState?.Expense_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        return accumulator + Number(Number(currentValue?.amount)?.toFixed(2));
      },
      0
    );

    return totalAmount;
  };
  const totalAmount = calculateTotalAmount();
  useEffect(() => {
    setFormState((formState) => ({
      ...formState,
      invoice_Amount: totalAmount,
    }));
  }, [totalAmount]);
  return (
    <>
      <HotTable
        data={formState?.Expense_Accounts_list || []}
        colHeaders={columnHeaders}
        columns={columns}
        manualRowResize={true}
        manualColumnResize={true}
        rowHeaders={true}
        height="200"
        rowHeaderWidth={25}
        contextMenu={true}
        filters={true}
        width="100%"
        hiddenColumns={{
          indicators: true,
          columns: [5],
        }}
        readOnly={disable}
        dropdownMenu={true}
        ref={hotRef}
        beforeChange={handleBeforeChange}
        beforeRemoveRow={handleBeforeRemoveRow}
        afterChange={handleAfterChange}
        licenseKey="non-commercial-and-evaluation" // for non-commercial use
      />
      <TableContainer>
        {formState?.Expense_Accounts_list?.length > 0 && (
          <TableRow>
            <TableCell colSpan={2} align="center">
              <b>Invoice Amount</b>
            </TableCell>
            <TableCell colSpan={3}>{totalAmount}</TableCell>
            {/* <TableCell colSpan={3}>{amountTotal}</TableCell> */}
          </TableRow>
        )}
        <Box display="flex" justifyContent={"flex-end"} mt={2}>
          <Button color="secondary" variant="contained" onClick={addInput}>
            Add New Row
          </Button>
        </Box>
      </TableContainer>
      {alertMessage && (
        <CustomSnackbar
          open={alertMessage !== ""}
          message={alertMessage}
          handleClose={() => setAlertMessage("")}
          variant="error"
        />
      )}
    </>
  );
}

export default ExpenseTable_V2;
